import { useQuery } from 'react-query';
import type { ISearchProduct } from '@/types';

export interface AssociatedProductsResponse {
  products: ISearchProduct[];
  facets: any[];
  found: number;
  out_of: number;
  page: number;
  search_time_ms: number;
}

const fetchAssociatedProducts = async (
  parentSku: string,
  associationType: string = 'generico',
): Promise<AssociatedProductsResponse> => {
  const params = new URLSearchParams({
    parentSku,
    associationType,
  });

  const response = await fetch(
    `/api/products/associated-products?${params.toString()}`,
  );

  if (!response.ok) {
    throw new Error('Failed to fetch associated products');
  }

  const data: AssociatedProductsResponse = await response.json();
  return data;
};

export const useAssociatedProducts = (
  parentSku: string | null | undefined,
  associationType: string = 'generico',
  enabled: boolean = true,
) => {
  return useQuery<AssociatedProductsResponse, Error>(
    ['associated-products', parentSku, associationType],
    () => fetchAssociatedProducts(parentSku!, associationType),
    {
      enabled: enabled && !!parentSku,
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 10, // 10 minutes
    },
  );
};

